export default function NoFilterButUnit ({ column: {id}}) {
    switch (id) {
        case "zugkilometer":
            return <label>(in km)</label>
        case 'zuschuss':
        case 'trassen':
        case 'station':
        case 'minder':
            return <label>(in €)</label>
        default:
            return <label></label>;
    }
}